import { appendAuthToken } from "../../../config/formAuth";
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Modal } from 'react-bootstrap';

import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

import { Select, message } from 'antd';
import NumberFormat from 'react-number-format';

import { combineLatest } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { userAssociatedFacilities, downloadUnperformedExamsList } from '../../../common/services/ApiService';

import Axios from '../../../config/axios';

import Moment from 'moment';

class UnperformedExamsReportModal extends Component {
    constructor(props) {
        super(props);

        var minus7 = new Date();
        minus7.setDate(minus7.getDate() - 7);

        var twoYearsAgo = new Date(new Date().setFullYear(new Date().getFullYear() - 2))

        this.state = {
            showModal: props.showModal,
            allFacilities: [],
            selectedFacilities: [],
            selectedDates: {
                startDate: twoYearsAgo,
                endDate: new Date()
            }
        }

        this.alive = false;
    }

    componentDidMount() {
        this.alive = true;

        combineLatest(
            userAssociatedFacilities
        ).pipe(takeWhile(() => this.alive)).subscribe(([f]) => {
            if (f?.length > 0) {

                let selectedFacilities = [];

                if (f.length === 1) {
                    selectedFacilities = [f[0].facilityModel.facilityID];
                }

                this.setState({
                    allFacilities: f,
                    selectedFacilities,
                    loaded: true
                }, () => {
                    if (f.length === 1) {
                        this.handleFacilityChange(selectedFacilities);
                    }

                });
            }
        });
    }

    componentWillUnmount() {
        this.alive = false;
    }

    handleFacilityChange = (selectedFacilities) => {
        // Check if "Select All" was just selected
        if (selectedFacilities.includes("Select All") && !this.state.selectedFacilities.includes("Select All")) {
            // Select all available facilities
            const allFacilityIds = this.state.allFacilities.map(f => f.facilityModel.facilityID);
            this.setState({
                selectedFacilities: allFacilityIds
            });
        }
        // Check if "Select All" was deselected (removed)
        else if (!selectedFacilities.includes("Select All") && this.state.selectedFacilities.includes("Select All")) {
            // Clear all selections
            this.setState({
                selectedFacilities: []
            });
        }
        // Check if "Select All" is currently selected but user selected/deselected individual items
        else if (this.state.selectedFacilities.includes("Select All") && selectedFacilities.includes("Select All")) {
            // Remove "Select All" from the selection and keep individual selections
            const filteredFacilities = selectedFacilities.filter(f => f !== "Select All");
            this.setState({
                selectedFacilities: filteredFacilities
            });
        }
        // Normal selection without "Select All"
        else {
            // Check if all individual items are now selected
            const allIndividualFacilities = this.state.allFacilities.map(f => f.facilityModel.facilityID);
            const hasAllItems = allIndividualFacilities.every(facility => selectedFacilities.includes(facility));
            
            if (hasAllItems && allIndividualFacilities.length === selectedFacilities.length) {
                // All items are selected, so show "Select All" as selected too
                this.setState({
                    selectedFacilities: ["Select All", ...selectedFacilities]
                });
            } else {
                // Regular selection
                this.setState({
                    selectedFacilities: selectedFacilities
                });
            }
        }
    }

    handleClear = () => {
        this.setState({
            selectedFacilities: [],
            selectedDates: {
                startDate: null,
                endDate: new Date()
            }
        })
    }

    handleNewDateChange = (name, date) => {
        this.setState({ selectedDates: { ...this.state.selectedDates, [name]: date } });
    }

    handleSubmit = () => {

        let endDate = this.state.selectedDates.endDate ? Moment(this.state.selectedDates.endDate).format("YYYY-MM-DD") : null;
        let startDate = this.state.selectedDates.startDate ? Moment(this.state.selectedDates.startDate).format("YYYY-MM-DD") : null;

        // Filter out "Select All" from selected facilities before submitting
        const facilitiesValue = this.state.selectedFacilities.filter(f => f !== "Select All");

        const q = Axios.defaults.baseURL + "api/RenderUnperformedExamReport";

        var form = document.createElement("form");
        form.target = "_blank";
        form.method = "POST";
        form.action = q;
        form.style.display = "none";

        var input = document.createElement("input");
        input.type = "hidden";
        input.name = "startDate";
        input.value = startDate;
        form.appendChild(input);

        var input = document.createElement("input");
        input.type = "hidden";
        input.name = "endDate";
        input.value = endDate;
        form.appendChild(input);

        var input = document.createElement("input");
        input.type = "hidden";
        input.name = "selectedFacilies";
        input.value = facilitiesValue;
        form.appendChild(input);

        var input = document.createElement("input");
        input.type = "hidden";
        input.name = "ianaTimezone";
        input.value = Intl.DateTimeFormat().resolvedOptions().timeZone;
        form.appendChild(input);

        appendAuthToken(form);
        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);

    }

    exportExcel = () => {
        //let endDate = this.state.selectedDates.endDate ? Moment(this.state.selectedDates.endDate).format("YYYY-MM-DD") : null;
        //let startDate = this.state.selectedDates.startDate ? Moment(this.state.selectedDates.startDate).format("YYYY-MM-DD") : null;

        const key = "loading";
        message.loading({ content: 'Exporting Unperformed Exams...', key, duration: 0 });
        let fileName = "uperformed-exams_" + Moment().format('YYYYMMDDHm') + '.xlsx';

        // Filter out "Select All" from selected facilities before submitting
        const facilitiesValue = this.state.selectedFacilities.filter(f => f !== "Select All");

        let postdata = {
            fileName,
            sDate: this.state.selectedDates.startDate ? Moment(this.state.selectedDates.startDate).format("YYYY-MM-DD") : null,
            eDate: this.state.selectedDates.endDate ? Moment(this.state.selectedDates.endDate).format("YYYY-MM-DD") : null,
            facilities: facilitiesValue,
            ianaTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone
        }

        downloadUnperformedExamsList(postdata).then(data => {
            const url = window.URL.createObjectURL(new Blob([data]));
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            // the filename you want
            a.download = fileName;//"File.xlsx";
            //document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);

            message.destroy(key);

            this.setState({
                downloading: false
            })
        }).catch(error => {
            console.log("Error");
        });
    }

    handleFilterCustom = (input, option) => {
        //console.log(input);
        //console.log(option);
    }


    render() {

        const { Option } = Select;

        const theme = window.sessionStorage.getItem("theme");

        return (
            <Modal size='lg' show={this.state.showModal} onHide={this.toggleModal} backdrop='static' dialogClassName={theme === 'dark' ? 'dark-theme' : 'light-theme'}>
                <Modal.Header>
                    <h1>Unperformed Exams</h1>
                </Modal.Header>
                <Modal.Body className="no-y-overflow">
                    <div className="panel-content">
                        {this.state.loaded &&
                            <div className="row">

                                <div className="form-group col col-6">
                                    <div className="form-label">Start Range</div>
                                    <DatePicker
                                        onChange={(date) => this.handleNewDateChange('startDate', date)}
                                        selectsStart
                                        startDate={this.state.selectedDates.startDate}
                                        endDate={this.state.selectedDates.endDate}
                                        className="form-control-custom"
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        placeholderText='Start Date'
                                        selected={this.state.selectedDates.startDate && Moment(this.state.selectedDates.startDate).toDate()}
                                        customInput={
                                            <NumberFormat format="##/##/####" mask="_" />
                                        }
                                    />
                                </div>
                                <div className="col col-6">
                                    <div className="form-label">End Range</div>
                                    <DatePicker
                                        onChange={(date) => this.handleNewDateChange('endDate', date)}
                                        selectsEnd
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        startDate={this.state.selectedDates.startDate}
                                        endDate={this.state.selectedDates.endDate}
                                        className="form-control-custom"
                                        placeholderText='End Date'
                                        selected={this.state.selectedDates.endDate && Moment(this.state.selectedDates.endDate).toDate()}
                                        customInput={
                                            <NumberFormat format="##/##/####" mask="_" />
                                        }
                                    />

                                </div>
                                <div className="form-group col col-lg-6 col-12">
                                    <div className="form-label">Facility</div>
                                    {this.state.allFacilities.length === 1 ?
                                        <div>{this.state.allFacilities[0].facilityModel.facilityName}</div>
                                        :
                                        <Select
                                            mode="multiple"
                                            maxTagCount={2}
                                            allowClear
                                            placeholder="Please select"
                                            onChange={this.handleFacilityChange}
                                            className="form-control-custom w-100"
                                            bordered={false}
                                            virtual={false}
                                            value={this.state.selectedFacilities}
                                            showSearch
                                            filterOption={(input, option) => (option.children[0] + option.children[1]).toLowerCase().includes(input.toLowerCase())}
                                        >
                                            <Option key="Select All" value="Select All">Select All</Option>
                                            {this.state.allFacilities.map((fac, idx) => <Option key={idx} key={fac.facilityModel.facilityID} value={fac.facilityModel.facilityID}>{fac.facilityModel.facilityNumber && fac.facilityModel.facilityNumber + " - "}{fac.facilityModel.facilityName}</Option>)}
                                        </Select>
                                    }

                                </div>
                            </div>


                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-submit float-left" onClick={this.handleSubmit} style={{ left: '10px', position: 'fixed', backgroundColor: '#1D6F42', borderColor: '#1D6F42' }}>Export to PDF</button>
                    <div className="row">
                        <div className="form-group col-12 padding-25-10">

                            <button className="btn btn-submit" onClick={this.exportExcel}>Run Report</button>
                            <button className="btn btn-outline-default margin-left-15" onClick={this.handleClear}>Clear</button>
                            <button className="btn btn-outline-default margin-left-15" id="closeModal" onClick={() => this.props.hideModal()}>Cancel</button>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default withRouter(UnperformedExamsReportModal);